
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { PackingProcess } from '../entities/packing-process';


export class PackingProcessRequest extends BaseRequest {
  
  packingProcess : PackingProcess;

  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.packingProcess = new PackingProcess();
  }

}